import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import styled, { css } from 'styled-components';
export const LinkStyles = css `
  ${transition('color, text-decoration-color')};
  ${fonts.brandonGrotesque.bold};

  display: inline-block;
  color: ${brand.black};
  font-size: ${fluid(16, 20)};
  line-height: 1.5;
  text-decoration: underline;
  text-decoration-color: ${brand.green};
  text-transform: uppercase;
  text-underline-position: under;

  &[data-size='small'] {
    font-size: ${fluid(14, 18)};
  }

  &[data-variant='white'] {
    color: ${brand.white};
    text-decoration-color: ${brand.white};
  }

  &:focus,
  &:hover {
    text-decoration-color: ${brand.black};
  }
`;
const Container = styled.a `
  ${LinkStyles};
`;
const CtaLinkStyles = {
    Container,
};
export default CtaLinkStyles;
